import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-custom-build-modern/build/ckeditor.js";
import React, { useEffect, useRef } from "react";
export { isRichTextEmpty } from "./richTextUtils";

interface ChannelRichEditorProps {
  value?: string;
  onChange?: (html: string) => void;
  placeholder?: string;
  minHeight?: number;
  isReadOnly?: boolean;
}

const ChannelRichEditor: React.FC<ChannelRichEditorProps> = ({
  value,
  onChange,
  placeholder,
  // minHeight = 120,
  isReadOnly = false,
}) => {
  const editorRef = useRef<any>(null);

  useEffect(() => {
    if (editorRef.current) {
      const currentData = editorRef.current.getData();
      const nextData = value ?? "";
      if (currentData !== nextData) {
        editorRef.current.setData(nextData);
      }
    }
  }, [value]);

  return (
    <CKEditor
      editor={ClassicEditor as any}
      config={{
        licenseKey: "GPL",
        placeholder: placeholder || "Write here...",
        toolbar: {
          items: [
            "bold",
            "italic",
            "underline",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "alignment",
            "|",
            "undo",
            "redo",
          ],
        },
      }}
      data={value ?? ""}
      onChange={(_event: any, editor: any) => {
        const html = editor.getData();
        if (onChange) onChange(html);
      }}
      onReady={(editor: any) => {
        editorRef.current = editor;
        if (isReadOnly) {
          editor.isReadOnly = true;
        }
      }}
      disableWatchdog={true}
    />
  );
};

export default ChannelRichEditor;
